import { gql } from "@apollo/client";

import { ACCOUNT_FULL_INFO } from "@/graphql-client/fragments";

export const GET_FILTERED_USERS = gql`
  query GetFilteredUsers(
    $skip: Int
    $take: Int
    $isTestUser: Boolean
    $specialistId: [Int!]
    $ProgramType: [String!]
    $sortColumn: String
    $sortOrder: SortOrder
    $name: String
  ) {
    accountsWithFilter(
      skip: $skip
      take: $take
      isTestUser: $isTestUser
      specialistId: $specialistId
      ProgramType: $ProgramType
      sortColumn: $sortColumn
      sortOrder: $sortOrder
      name: $name
    ) {
      accounts {
        ...AccountFullInfo
        nextScheduledCall
        callPlans {
          programWeek
          isActive
        }
      }
      total
    }
  }
  ${ACCOUNT_FULL_INFO}
`;

export const GET_DEACTIVATED_USERS = gql`
  query GetDeactivatedUsers($skip: Int, $take: Int) {
    deactivatedAccounts(skip: $skip, take: $take) {
      deactivatedAccounts {
        id
        firstName
        lastName
        deletedAt
        createdOn
      }
      totalDeactivatedCount
    }
  }
`;
